import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { NamePlatePhoto } from "@/components/installFlowV2/name-plate-photo";
import { isAuthenticated } from "@/auth";

export const Route = createFileRoute("/installFlow/name-plate-photo")({
  component: NamePlatePhoto,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    const authenticated = isAuthenticated();
    if (!authenticated) {
      throw redirect({ to: "/login" });
    }
  },
});
